import { render, staticRenderFns } from "./TeacherProfileHub.vue?vue&type=template&id=56abfedf"
import script from "./TeacherProfileHub.vue?vue&type=script&lang=js"
export * from "./TeacherProfileHub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56abfedf')) {
      api.createRecord('56abfedf', component.options)
    } else {
      api.reload('56abfedf', component.options)
    }
    module.hot.accept("./TeacherProfileHub.vue?vue&type=template&id=56abfedf", function () {
      api.rerender('56abfedf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/teacher/TeacherProfileHub.vue"
export default component.exports